  function initializeFacetButtons() {
    // Remove existing event listeners to prevent duplicates
    const existingButtons = document.querySelectorAll('.show-more-btn[data-initialized="true"]');
    existingButtons.forEach(btn => {
      btn.replaceWith(btn.cloneNode(true));
    });

    const wrappers = document.querySelectorAll('.facet-wrapper');

    wrappers.forEach(wrapper => {
      const showMoreBtn = wrapper.querySelector('.show-more-btn');
      const allItems = wrapper.querySelectorAll('.facets__item');
      const maxVisibleItems = parseInt(showMoreBtn?.className.match(/\d+/)?.[0]) || 5;

      if (showMoreBtn && !showMoreBtn.getAttribute('data-initialized')) {
        // Mark as initialized to prevent duplicate event listeners
        showMoreBtn.setAttribute('data-initialized', 'true');
        
        // Set initial state based on current visibility
        const hiddenItems = wrapper.querySelectorAll('.facets__item.hidden-item');
        const isExpanded = hiddenItems.length === 0 && allItems.length > maxVisibleItems;
        showMoreBtn.setAttribute('data-expanded', isExpanded.toString());
        showMoreBtn.textContent = isExpanded ? 'View less' : 'View all';

        // Ensure initial state is correct
        if (!isExpanded) {
          allItems.forEach((item, index) => {
            if (index >= maxVisibleItems) {
              item.classList.add('hidden-item');
            }
          });
        }

        showMoreBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          
          const currentState = showMoreBtn.getAttribute('data-expanded') === 'true';

          if (currentState) {
            // Collapse: Hide items after maxVisibleItems
            allItems.forEach((item, index) => {
              if (index >= maxVisibleItems) {
                item.classList.add('hidden-item');
              }
            });
            showMoreBtn.textContent = 'View all';
            showMoreBtn.setAttribute('data-expanded', 'false');
          } else {
            // Expand: Show all items
            allItems.forEach(item => {
              item.classList.remove('hidden-item');
            });
            showMoreBtn.textContent = 'View less';
            showMoreBtn.setAttribute('data-expanded', 'true');
          }
        });
      }
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', initializeFacetButtons);

  // Reinitialize after AJAX updates (for Shopify's facet filtering)
  document.addEventListener('facet:update', initializeFacetButtons);
  
  // For themes that use different event names
  document.addEventListener('shopify:section:load', initializeFacetButtons);
  
  // Fallback for mutation observer (when DOM changes)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      let shouldReinit = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          const hasNewFacetContent = addedNodes.some(node => 
            node.nodeType === 1 && 
            (node.classList?.contains('facets__item') || 
             node.querySelector?.('.facets__item'))
          );
          if (hasNewFacetContent) {
            shouldReinit = true;
          }
        }
      });
      
      if (shouldReinit) {
        // Small delay to ensure DOM is fully updated
        setTimeout(initializeFacetButtons, 100);
      }
    });

    // Observe the facets container for changes
    const facetsContainer = document.querySelector('.facets-container');
    if (facetsContainer) {
      observer.observe(facetsContainer, {
        childList: true,
        subtree: true
      });
    }
  }